import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://consulte-nome-api-1.onrender.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (email, password, name) => api.post('/auth/register', { email, password, name });
export const loginWithGoogle = (token) => api.post('/auth/google', { token });
export const verify2FA = (email, code) => api.post('/auth/verify-2fa', { email, code });
export const resend2FA = (email) => api.post('/auth/resend-2fa', { email });

// CPF Consultation
export const consultCPF = (cpf) => api.post('/consult-cpf', { cpf });

// CNPJ Consultation
export const consultCNPJ = (cnpj) => api.post('/consult-cnpj', { cnpj });

// User
export const getProfile = () => api.get('/user/profile');
export const saveConsultation = (cpf, result) => api.post('/user/consultations', { cpf, result });



// Admin
export const getAdminDashboard = () => api.get('/admin/dashboard');
export const getLeads = () => api.get('/admin/leads');
export const getVisits = (period) => api.get(`/admin/visits?period=${period}`);
export const setup2FA = () => api.post('/admin/2fa/setup');
export const verify2FAAdmin = (code) => api.post('/admin/2fa/verify', { code });
export const check2FAStatus = () => api.get('/admin/2fa/status');


// Partners
export const getPartners = () => api.get('/partners');
export const redirectToPartner = (partnerId, leadId) => api.post('/partners/redirect', { partnerId, leadId });

// Negotiate debt
export const negotiateDebt = (data) => api.post('/negociar-divida', data);
export const getAgreements = () => api.get('/acordos');

export default api;